<template>
  <div>
    <v-form ref="itemForm" v-model="itemValid">
      <!-- <v-form ref="secondStep" v-model="secondFormValid"> -->
      <v-stepper-step :complete="stepperProp > 2" step="2">
        <v-row class="pa-2">
          <h5 class="text--secondary">ثبت اقلام سفارش</h5>
          <HelperComponent helperId="trade-request-item-info" class="mx-2" />
        </v-row>
      </v-stepper-step>
      <v-stepper-content step="2">
        <v-form ref="secondStep" v-model="secondFormValid">
          <v-sheet outlined class="pa-4 my-4">
            <v-row v-if="canSearchSupplierProduct">
              <v-card-text>
                <supplier-sale-products-list
                  @selectedDataFunc="selectedDataFunc"
                />
              </v-card-text>
            </v-row>
            <v-row v-if="canSearchSupplierProduct">
              <v-col cols="12">
                <v-text-field
                  dense
                  outlined
                  readonly
                  label="عنوان کالا یا خدمت انتخاب شده"
                  v-model="categoryDetails"
                  required
                  :rules="[
                    (v) =>
                      !!v ||
                      'یک کالا یا خدمت مورد نظر برای سفارش را از طریق جستجو، انتخاب کنید',
                  ]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                :md="category == 'IndustrialService' ? 12 : 12"
              >
                <v-text-field
                  v-model="form.title"
                  dense
                  required
                  readonly
                  :rules="[(v) => !!v || 'وارد کردن مقدار الزامی می‌باشد']"
                  outlined
                  label="موضوع سفارش *"
                ></v-text-field>
              </v-col>

              <v-col cols="12" :md="category == 'IndustrialService' ? 4 : 6">
                <v-text-field
                  v-model="form.quantity"
                  type="number"
                  placeholder="صفحه کلید به انگلیسی باشد"
                  dense
                  required
                  :rules="[(v) => !!v || 'وارد کردن مقدار الزامی می‌باشد']"
                  label="تعداد *"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" :md="category == 'IndustrialService' ? 4 : 6">
                <v-autocomplete
                  item-text="title"
                  item-value="id"
                  :items="unitMeasurmentItems"
                  persistent-hint
                  clearable
                  dense
                  :rules="[(v) => !!v || '    انتخاب یک مورد الزامی می‌باشد']"
                  required
                  outlined
                  placeholder="برای جستجو واحد شمارش را تایپ کنید"
                  label="واحد شمارش*"
                  :search-input.sync="measurementUnit"
                  v-model="form.measurementUnitId"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="4" v-if="category == 'IndustrialService'">
                <v-select
                  :required="category == 'IndustrialService' ? 'true' : 'false'"
                  :rules="
                    category == 'IndustrialService'
                      ? [(v) => !!v || 'وارد کردن مقدار الزامی می‌باشد']
                      : []
                  "
                  item-text="displayName"
                  item-value="title"
                  :items="rawMaterialSupplyTypes()"
                  v-model="form.materialSupplyType"
                  dense
                  outlined
                  label="نحوه‌ی تامین مواد اولیه"
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4" v-if="category == 'IndustrialService'">
                <v-select
                  :items="rawMaterials"
                  :required="category == 'IndustrialService' ? 'true' : 'false'"
                  :rules="
                    category == 'IndustrialService'
                      ? [(v) => !!v || 'وارد کردن مقدار الزامی می‌باشد']
                      : []
                  "
                  item-text="title"
                  item-value="id"
                  persistent-hint
                  clearable
                  v-model="form.rawMaterialId"
                  dense
                  outlined
                  label="جنس مواد اولیه"
                ></v-select>
              </v-col>
              <!-- <v-col cols="12" :md="category == 'IndustrialService' ? 4 : 6">
                <v-select
                  v-model="form.deliveryLocation"
                  :items="deliveryLocationItems()"
                  required
                  :rules="[(v) => !!v || 'وارد کردن مقدار الزامی می‌باشد']"
                  item-text="displayName"
                  item-value="title"
                  persistent-hint
                  clearable
                  dense
                  outlined
                  label="محل تحویل "
                ></v-select>
              </v-col> -->
              <!-- <v-col cols="12">
                <v-text-field
                  v-model="form.description"
                  dense
                  :required="form.description && form.description.length > 0"
                  :rules="[
                    (v) => {
                      if (v && (v.length > 2048 || v.length < 5)) {
                        return 'تعداد کاراکتر ها باید بین 5 تا 2048 عدد باشد';
                      } else return true;
                    },
                  ]"
                  label="توضیحات (اختیاری)"
                  outlined
                ></v-text-field>
              </v-col> -->
              <!-- <v-col cols="12" md="6"> </v-col> -->
            </v-row>
            <v-row>
              <v-col cols="12">
                <h5 class="text--secondary">
                  برنامه مورد نظر جهت تحویل گیری( یکجا/ در تاریخهای مختلف)*
                </h5>
              </v-col>
            </v-row>
            <v-col cols="12">
              <v-radio-group
                v-model="form.deliveryType"
                row
                required
                @change="form.requireDateUtc = ''"
                :rules="[(v) => !!v || 'یک مورد انتخاب کنید']"
              >
                <v-radio label="یکجا" value="Entirely"></v-radio>
                <v-radio label="ادواری" value="Periodical"></v-radio>
              </v-radio-group>

              <v-row
                class="px-2 mt-n6"
                v-if="form.deliveryType && form.deliveryType.length"
              >
                <v-col cols="12" md="6">
                  <date-picker
                    v-model="form.requireDateUtc"
                    :label="
                      form.deliveryType == 'Entirely'
                        ? 'تاریخ نیاز'
                        : 'تاریخ شروع اولین محموله'
                    "
                    format="YYYY/MM/DD"
                    display-format="jYYYY/jMM/jDD"
                    ref="requireDateUtc"
                    :initial-value="formattedDate"
                    :min="addDaysToDate(1)"
                  ></date-picker>
                </v-col>
                <v-col cols="12" md="6"> </v-col>
                <v-col
                  cols="12"
                  md="4"
                  v-if="form.deliveryType == 'Periodical'"
                >
                  <date-picker
                    :readonly="form.deliveryType == 'Entirely' ? true : false"
                    v-model="singleDeliveryItem.deliveryDateUtc"
                    label="تاریخ انتخاب*"
                    format="YYYY/MM/DD"
                    display-format="jYYYY/jMM/jDD"
                    ref="deliveryDateUtc"
                    :initial-value="form.requireDateUtc"
                    :min="form.requireDateUtc"
                  ></date-picker>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  v-if="form.deliveryType == 'Periodical'"
                >
                  <v-text-field
                    v-model="singleDeliveryItem.amount"
                    label="تعداد*"
                    type="number"
                    dense
                    placeholder="صفحه کلید به انگلیسی باشد"
                    required
                    :rules="[(v) => !!v || 'وارد کردن مقدار الزامی می‌باشد']"
                    persistent-hint
                    outlined
                    :readonly="
                      form.deliveryType == 'Entirely' &&
                      singleDeliveryItem.amount == form.quantity
                        ? true
                        : false
                    "
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="3" md="1" v-if="form.deliveryType == 'Periodical'">
                  <v-btn
                    color="primary"
                    :disabled="
                      singleDeliveryItem.amount == null ||
                      singleDeliveryItem.deliveryDateUtc == null
                        ? true
                        : false
                    "
                    @click="addDeliveryItem()"
                  >
                    ثبت
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <DeliveryItemsList
                v-if="
                  form.deliveryItems &&
                  form.deliveryItems.length &&
                  deliveryflag == false
                "
                :items="form.deliveryItems"
                @removeDeliveryItem="removeDeliveryItem"
              />
            </v-col>
          </v-sheet>
          <v-btn
            class="mx-2"
            color="primary"
            @click="
              $refs.secondStep.validate()
                ? deliveryItemsValidation()
                : validationErrorModal()
            "
          >
            گام بعد
          </v-btn>
          <v-btn class="mx-2" color="primary" @click="stepperProp = 1">
            گام قبل
          </v-btn>
        </v-form>
      </v-stepper-content>

      <v-stepper-step :complete="stepperProp > 3" :step="3">
        <v-row class="pa-2">
          <h5 class="text--secondary">ثبت مدارک پیوست</h5>
          <HelperComponent
            helperId="trade-request-attachment-info"
            class="mx-2"
          />
        </v-row>
      </v-stepper-step>
      <v-stepper-content :step="3">
        <v-form ref="thirdStep" v-model="thirdFormValid">
          <v-sheet outlined class="pa-4 my-4">
            <v-col cols="12" md="6">
              <span
                >فقط فایل هایی از نوع jpg,.jpeg,.png,.gif,.webp,.bmp,.svg,.pdf
                قابل قبول می‌باشد.
              </span>
              <v-select
                item-text="title"
                item-value="id"
                persistent-hint
                clearable
                dense
                outlined
                label="فایل اطلاعات پیوست*"
                :items="attachInformationFileList"
                v-model="document.documentTypeId"
              >
                <template v-slot:item="{ item }">
                  <label>
                    {{ item.title
                    }}{{ item.required ? ' (اجباری) ' : ' (اختیاری) ' }}
                  </label>
                </template>
              </v-select>

              <span
                class="red--text mt-n3"
                v-if="
                  validationErr &&
                  !validationErr.validate &&
                  validationErr.errorMessage
                "
              >
                {{ validationErr.errorMessage }}
              </span>
              <v-card
                max-width="700"
                class="my-3"
                v-if="document.documentTypeId && document.documentTypeId.length"
              >
                <v-row>
                  <v-card-text>
                    <v-col cols="12">
                      <v-text-field
                        label="توضیحات فایل"
                        v-model="document.description"
                        dense
                        outlined
                        :required="
                          document.description &&
                          document.description.length > 0
                        "
                        :rules="[
                          (v) => {
                            if (v && (v.length > 2048 || v.length < 5)) {
                              return 'تعداد کاراکتر ها باید بین 5 تا 2048 عدد باشد';
                            } else return true;
                          },
                        ]"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-file-input
                        style="direction: ltr"
                        label="انتخاب فایل"
                        outlined
                        show-size
                        ref="file"
                        :rules="[
                          (v) => !!v || 'وارد کردن مقدار الزامی می‌باشد',
                        ]"
                        required
                        :clearable="false"
                        dense
                        @change="uploadFile($event)"
                        >انتخاب فایل</v-file-input
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        label="انتخاب به عنوان تصویر پیش فرض"
                        v-model="document.isDefault"
                        :disabled="document.disableCheckBox"
                      ></v-checkbox>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="float-left"
                        color="primary"
                        @click="addFile()"
                        >افزودن
                      </v-btn>
                    </v-col>
                  </v-card-text>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12">
              <TradeDocumentFileList
                v-if="attachedItems && attachedItems.length"
                :items="attachedItems"
                @removeAttachedItem="removeAttachedItem"
                @addToDefault="addToDefault"
                :type="'upload'"
              />
            </v-col>
          </v-sheet>
          <v-btn color="primary" class="mx-2" @click="documentValidation()">
            گام بعد
          </v-btn>
          <v-btn
            color="primary"
            class="mx-2"
            @click="stepperProp = stepperProp - 1"
          >
            گام قبل
          </v-btn>
        </v-form>
      </v-stepper-content>
      <v-stepper-step :complete="stepperProp > 3" :step="4">
        <v-row class="pa-2">
          <h5 class="text--secondary">مدارک پیوست مورد نیاز جهت پاسخ دهی</h5>
          <HelperComponent
            helperId="trade-request-attachment-info"
            class="mx-2"
          />
        </v-row>
      </v-stepper-step>
      <v-stepper-content :step="4">
        <v-form ref="forthStep" v-model="forthFormValid">
          <v-sheet outlined class="pa-4 my-4">
            <v-card max-width="700" class="my-3">
              <v-row>
                <v-card-text>
                  <v-col cols="12">
                    <v-select
                      item-text="title"
                      item-value="id"
                      persistent-hint
                      clearable
                      dense
                      outlined
                      label="نوع مدرک انتخاب شود*"
                      :items="attachInformationFileListForResponse"
                      v-model="responseDocument.documentTypeId"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="عنوان دلخواه"
                      v-model="responseDocument.subTitle"
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-switch
                      v-model="responseDocument.isOptional"
                      :label="
                        'اختیار الصاق مدرک در پاسخ سفارش' +
                        (responseDocument.isOptional ? '(اختیاری)' : '(اجباری)')
                      "
                    ></v-switch>
                  </v-col>
                  <v-col cols="12">
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="!closeStepper"
                      class="float-left"
                      color="primary"
                      @click="responseDocumentAddFile()"
                      >افزودن
                    </v-btn>
                  </v-col>
                </v-card-text>
              </v-row>
            </v-card>
            <v-col cols="12" md="9">
              <TradeDocumentFileList
                v-if="responseAttachedItems && responseAttachedItems.length"
                :items="responseAttachedItems"
                @removeAttachedItem="removeResponseAttachedItem"
                :type="'response'"
              />
            </v-col>
          </v-sheet>
          <!-- <v-btn
            color="primary"
            class="mx-2"
            @click="responseDocumentValidation()"
          >
            گام بعد
          </v-btn> -->
          <v-btn
            v-if="!closeStepper"
            color="primary"
            class="mx-2"
            @click="stepperProp = stepperProp - 1"
          >
            گام قبل
          </v-btn>

          <v-btn
            color="primary"
            @click="stepperProp = 1"
            class="mx-2"
            v-if="!closeStepper"
          >
            گام اول
          </v-btn>

          <v-btn
            :disabled="addItemDisabled"
            color="primary"
            @click="addOrEditItem()"
            v-if="!closeStepper"
            class="mx-2"
          >
            {{
              $store.getters.tradeRequestEditMode
                ? 'ویرایش آیتم'
                : 'افزودن آیتم'
            }}
          </v-btn>
        </v-form>
      </v-stepper-content>
    </v-form>
  </div>
</template>

<script>
// tradeRequestEditMode ==> iit is used when new from is created and one intends to edit an item of the form (there are no unique Id yet so we have to create one)
// $store.isForEdit => when the previous made form needs to be edited so we can get the Id by server (no need to use uuid)
import SupplierSaleProductsList from './SupplierSaleProductsList.vue';
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import { GET_ENUMS } from '../../enums/store/types';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import TradeDocumentFileList from './TradeDocumentFileList.vue';
import DeliveryItemsList from './DeliveryItemsList.vue';
import tradeRequestFormTreeSelect from './tradeRequestFormTreeSelect';
import { RepoFactory } from '@/baseRepository/Factory';
const unitOfMeasurementsRepository = () =>
  RepoFactory.get('unitOfMeasurements');
const rawMaterialRepository = () => RepoFactory.get('rawMaterial');
const filesRepository = () => RepoFactory.get('files');
const tradeRequestRepository = () => RepoFactory.get('tradeRequests');
import { uuid } from 'vue-uuid';
import Helper from '@/core/helpers';
const initialFormData = {
  title: '',
  quantity: null,
  requireDateUtc: null,
  description: '',
  materialSupplyType: '',
  rawMaterialId: null,
  supplierProductId: null,
  documents: [],
  techInfos: [],
  measurementUnitId: null,
  inventoryItemId: null,
  deliveryType: null,
  deliveryItems: [],
  deliveryLocation: '',
  tradeRequestItemType: '',
  technicalHelpNeeded: false,
  responseDocuments: [],
};
export default {
  props: {
    bidExpirationInDays: {},
    editBtnPressed: {
      type: Boolean,
      default: false,
    },
    reset: {
      type: Boolean,
      default: false,
    },
    stepper: {
      type: Number,
      default: 1,
    },
    // category: {
    //   type: String,
    //   default: '',
    // },
    request: {
      type: String,
      default: 'DirectOrder',
    },
    checkRegisterOrderOrEditOrderIsDisableFlag: {
      type: Boolean,
      default: false,
    },
    selectedSupplierProduct: {
      type: Array,
      default: [],
    },
    SelectedCategoryDetails: {
      type: String,
      default: '',
    },
    formHasItemProp: {
      type: Boolean,
      default: false,
    },
    cannSearchSupplierProductProp: {
      type: Boolean,
      defalut: false,
    },
  },
  mixins: [asyncLoadMixin, reusableMethodsMixin],
  components: {
    datePicker: VuePersianDatetimePicker,
    tradeRequestFormTreeSelect,
    TradeDocumentFileList,
    DeliveryItemsList,
    SupplierSaleProductsList,
  },
  data() {
    return {
      formattedDate: null,
      secondFormValid: true,
      thirdFormValid: true,
      forthFormValid: true,
      techInfos: [],
      productProperties: [],
      closeStepper: false,
      category: '',
      categoryIds: [],
      editDeliveryFlag: false,
      categoriesList: [],
      resetTree: false,
      validationErr: {
        validate: true,
        errorMessage: '',
      },
      deliveryflag: false,
      singleDeliveryItem: {
        deliveryDateUtc: null,
        amount: null,
      },
      deliveryItemsList: [],
      tempStorage: [],
      singleAttachedItem: {},
      attachedItems: [],
      responseAttachedItems: [],
      measurementUnit: '',
      titleLoading: false,
      rawMaterials: [],
      showUploadForm: false,
      loadingCategoryTree: false,
      resetForm: false,
      unitMeasurmentItems: [],
      form: { ...initialFormData },
      attachInformationFileList: [],
      attachInformationFileListForResponse: [],
      attachInformationFileSelected: '',
      deliveryDurationItems: [],
      file: null,
      categoryItems: [],
      categoryListItems: [],
      // finalListItems:[],
      itemValid: true,
      productCategoryId: null,
      document: {
        documentTypeId: null,
        fileId: '',
        description: '',
        expirationDateUtc: '',
        isDefault: false,
        disableCheckBox: false,
      },
      responseDocument: {
        isOptional: false,
        subTitle: '',
        documentTypeId: null,
      },
      supplierId: null,
      supplierProduct: [],
      categoryDetails: '',
      addItemDisabled: false,
      canSearchSupplierProduct: this.editItem ?? false,
      formHasItem: false,
      selectedCategoryType: '', // For validation on creating order , each order should have unique CategoryType
      selectedSupplierId: '', // For validation on creating order , each order should have unique  supplierId
    };
  },
  computed: {
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    baseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    inventoryBaseUrl() {
      return this.$store.getters.inventoryBaseUrl;
    },
    productBaseUrl() {
      return this.$store.getters.productBaseUrl;
    },
    currentMerchant() {
      return this.$store.getters.currentMerchant;
    },
    fileBaseUrl() {
      return this.$store.getters.fileBaseUrl;
    },
    stepperProp: {
      get() {
        return this.stepper;
      },
      set(val) {
        this.$emit('changeStepper', val);
      },
    },
  },
  watch: {
    addItemDisabled(af, be) {
      console.log('addItemDisabled' + af + 'befor is :' + be);
    },
    formHasItemProp(after, befor) {
      this.formHasItem = after;
    },
    selectedSupplierProduct(after, befor) {
      this.supplierProduct = after;
      if (after) {
        this.selectedSupplierId = after[0].supplierId;
        // this.selectedCategoryType = after[0].categoryType;
        if (after[0]?.categoryType) {
          this.selectedCategoryType = after[0].categoryType;
          this.$store.commit(
            'setTradeRequestCategoryType',
            after[0]?.categoryType
          );
        }
        if (after[0]?.category) {
          this.selectedCategoryType = after[0].category;
          this.$store.commit('setTradeRequestCategoryType', after[0]?.category);
        }
      }
    },
    supplierProduct(after, befor) {
      if (after) {
        this.form.title =
          after[0]?.name + ' از ( ' + after[0]?.supplierName + ')';
        //this.category = after[0]?.categoryType ?? after[0]?.category;
        if (after[0]?.categoryType) {
          this.category = after[0]?.categoryType;
          this.$store.commit(
            'setTradeRequestCategoryType',
            after[0]?.categoryType
          );
        }
        if (after[0]?.category) {
          this.category = after[0]?.category;
          this.$store.commit('setTradeRequestCategoryType', after[0]?.category);
        }
        this.supplierId = after[0]?.supplierId;
        this.form.supplierId = after[0]?.supplierId;
        this.form.supplierProductId = after[0]?.id;
        this.getAttachmentFileList();
        this.getAttachmentFileListForResponse();
      }
    },
    stepper(newval, oldval) {
      if (newval == 2) {
        if (this.$store.getters.tradeRequestIsEdit && this.addItemDisabled) {
          this.canSearchSupplierProduct = true;
          return;
        }
        if (this.formHasItem && newval == 2 && this.addItemDisabled) {
          this.canSearchSupplierProduct = true;
          return;
        }
        if (this.editItem && newval == 2) {
          this.canSearchSupplierProduct = false;
          return;
        }

        if (!this.$store.getters.tradeRequestEditMode && this.formHasItem) {
          this.canSearchSupplierProduct = true;
          //this.$emit('formHasItemFun', true);
          return;
        } else {
          this.canSearchSupplierProduct = false;
        }
      }
      //Add or edit Item is :
      if (newval == 4 && this.$store.getters.tradeRequestEditMode) {
        this.addItemDisabled = false;
      }
    },
    bidExpirationInDays(after, before) {
      if (after > 0) {
        this.addDaysToDate(after);
      }
    },
    reset() {
      let app = this;
      if (app.reset) {
        app.form = {
          title: '',
          quantity: '',
          requireDateUtc: null,
          description: '',
          materialSupplyType: '',
          rawMaterialId: null,
          documents: [],
          techInfos: [],
          measurementUnitId: null,
          inventoryItemId: null,
          deliveryType: null,
          deliveryItems: [],
          deliveryLocation: '',
          tradeRequestItemType: '',
          technicalHelpNeeded: false,
          responseDocuments: [],
        };
        app.attachedItems = [];
        app.responseAttachedItems = [];
        app.resestForm();
        app.resetTree = false;
        app.resetTree = true;
        let temp = this.$store.getters.tradeRequestCategoryType;
        this.$store.commit('setTradeRequestCategoryType', null);
        this.$store.commit('setTradeRequestCategoryType', temp);
        app.DeliveryDurationType();
        app.getRawMaterial();
        app.getAttachmentFileList();
        app.getAttachmentFileListForResponse();
        app.$emit('changeReset');
      }
    },
    'form.requireDateUtc': function () {
      this.addDeliveryItem();
      if (this.form.deliveryType == 'Entirely') {
        this.singleDeliveryItem.deliveryDateUtc = this.form.requireDateUtc;
      } else if (
        this.form.deliveryType == 'Periodical' &&
        this.form.deliveryItems.length == 0
      ) {
        this.singleDeliveryItem.deliveryDateUtc = this.form.requireDateUtc;
      }
    },
    'form.quantity': function () {
      if (this.form.deliveryType == 'Entirely') {
        this.singleDeliveryItem.amount = parseInt(this.form.quantity);
      }
    },
    'form.techInfos': function () {},
    attachInformationFileList: function () {},
    'form.technicalHelpNeeded': function () {
      if (this.form.technicalHelpNeeded == true) {
        this.form.techInfos = [];
        // this.resetTree = false;
        // this.resetTree = true;
      }
    },
    '$store.getters.tradeRequestSingleItemForEdit': function () {
      if (
        (this.$store.getters.tradeRequestEditMode ||
          this.$store.getters.tradeRequestIsEdit) &&
        this.$store.getters.tradeRequestSingleItemForEdit &&
        Object.keys(this.$store.getters.tradeRequestSingleItemForEdit).length
      ) {
        this.fillEditInput();
      }
    },
    productCategoryId() {
      this.getProductCategoryById();
    },
    measurementUnit() {
      this.getUnitsOfMeasurement(this.measurementUnit);
    },
    'form.deliveryType': function (before, after) {
      if (
        /*(this.tradeRequestEditMode && editDeliveryFlag ) ||*/ !this.$store
          .getters.tradeRequestEditMode
      ) {
        this.deliveryItemsList = [];
        this.deliveryflag = false;
        this.form.deliveryItems = [];
        if (this.form.deliveryType == 'Entirely') {
          this.singleDeliveryItem.amount = parseInt(this.form.quantity);
          this.singleDeliveryItem.deliveryDateUtc = this.form.requireDateUtc;
        } else if (this.form.deliveryType == 'Periodical') {
          this.singleDeliveryItem.amount = null;
        }
      } else {
        if (before != null && after != null) {
          this.deliveryItemsList = [];
          this.deliveryflag = false;
          this.form.deliveryItems = [];
          if (this.form.deliveryType == 'Entirely') {
            this.singleDeliveryItem.amount = parseInt(this.form.quantity);
            this.singleDeliveryItem.deliveryDateUtc = this.form.requireDateUtc;
          } else if (this.form.deliveryType == 'Periodical') {
            this.singleDeliveryItem.amount = null;
          }
        }
      }
    },

    'form.quantity': function () {
      if (this.form.deliveryType == 'Entirely') {
        this.singleDeliveryItem.amount = parseInt(this.form.quantity);
      }
    },
    request(after, before) {
      // consonle.log("request After");
      // consonle.log(after);
      if (after.length && this.category && this.category.length) {
        this.getAttachmentFileList();
        this.getAttachmentFileListForResponse();
      }
    },
    // category(after, before) {
    //   if (after.length && this.request && this.request.length) {
    //     this.getAttachmentFileList();
    //     this.getAttachmentFileListForResponse();
    //   }
    // },
  },
  async created() {
    // console.log("TradeRequest is : " + this.request

    this.cannSearchSupplierProduct = this.cannSearchSupplierProductProp;
    this.addItemDisabled = this.checkRegisterOrderOrEditOrderIsDisableFlag;
    // this.supplierProduct = this.selectedSupplierProduct;
    this.form = { ...initialFormData };
    if (!this.$store.getters.allEnums.length) {
      await this.$store.dispatch(GET_ENUMS);
    }
    if (
      this.$store.getters.tradeRequestSingleItemForEdit &&
      Object.keys(this.$store.getters.tradeRequestSingleItemForEdit).length
    ) {
      this.fillEditInput();
    }

    this.DeliveryDurationType();
    this.getRawMaterial();
    // if (
    //   this.request &&
    //   this.request.length &&
    //   this.category &&
    //   this.category.length
    // ) {
    //    this.getAttachmentFileList();
    //    this.getAttachmentFileListForResponse();
    // }
  },
  mounted() {},

  methods: {
    validationErrorModal() {
      this.$dialog.error({
        text: 'وارد کردن موارد ستاره دار الزامی می‌باشد',
        title: 'خطا',
        persistent: true,
        actions: [
          {
            text: 'بستن',
            color: 'red',
          },
        ],
      });
    },
    addDaysToDate(intDays) {
      if (intDays > 0) {
        let days = parseInt(intDays);
        let currentDateObj = new Date();
        let numberOfMlSeconds = currentDateObj.getTime();
        let addMlSeconds = days * 24 * 60 * 60 * 1000;
        let newDateObj = new Date(numberOfMlSeconds + addMlSeconds);
        let year = newDateObj.toLocaleString('default', { year: 'numeric' });
        let month = newDateObj.toLocaleString('default', { month: '2-digit' });
        let day = newDateObj.toLocaleString('default', { day: '2-digit' });
        this.formattedDate = String(year + '/' + month + '/' + day);
        return this.formattedDate;
      }
    },
    resestForm() {
      // this codes moved to new function (clearFormAfterAddedToStore)
      // this.responseDocument = {
      //   isOptional: false,
      //   subTitle: '',
      //   documentTypeId: null,
      // };
      // this.secondFormValid = true;
      // this.thirdFormValid = true;
      // this.forthFormValid = true;
      // this.techInfos = [];
      // this.productProperties = [];
      // this.form.documents = [];
      // this.closeStepper = false;
      // // this.categoryType=null
      // this.editDeliveryFlag = false;
      // this.categoriesList = [];
      // this.resetTree = false;
      // (this.deliveryflag = false),
      //   (this.deliveryItemsList = []),
      //   (this.tempStorage = []),
      //   (this.singleAttachedItem = {}),
      //   (this.attachedItems = []),
      //   (this.responseAttachedItems = []),
      //   (this.measurementUnit = ''),
      //   (this.titleLoading = false),
      //   (this.rawMaterial = []),
      //   (this.showUploadForm = false),
      //   (this.loadingCategoryTree = false),
      //   (this.resetForm = false),
      //   (this.unitMeasurmentItems = []),
      //   (this.form = { ...initialFormData }),
      //   (this.form.documents = []);
      // (this.attachInformationFileList = []),
      //   (this.attachInformationFileSelected = ''),
      //   (this.deliveryDurationItems = []),
      //   (this.file = null),
      //   (this.categoryItems = []),
      //   (this.categoryListItems = []),
      //   (this.itemValid = true),
      //   (this.productCategoryId = null),
      //   (this.validationErr = {
      //     validate: true,
      //     errorMessage: '',
      //   }),
      //   (this.singleDeliveryItem = {
      //     deliveryDateUtc: null,
      //     amount: null,
      //   }),
      //   (this.document = {
      //     documentTypeId: null,
      //     fileId: '',
      //     description: '',
      //     expirationDateUtc: '',
      //     isDefault: false,
      //     disableCheckBox: false,
      //   });
    },
    getTradeRequestItemPropertyValues(properties, categoryId) {
      let app = this;
      let techInfo = {
        productCategoryId: null,
        processType: null,
        tradeRequestItemPropertyValues: null,
      };
      techInfo.productCategoryId = categoryId[0];
      techInfo.processType = 'MainProcess';
      techInfo.tradeRequestItemPropertyValues = properties;
      if (
        this.$store.getters.tradeRequestIsEdit &&
        this.$store.getters.tradeRequestEditMode
      ) {
        techInfo.id = app.form.techInfos[0].id;
      } else if (
        this.$store.getters.tradeRequestIsEdit &&
        !this.$store.getters.tradeRequestEditMode
      ) {
        techInfo.id = null;
      }

      app.form.techInfos = [];
      app.form.techInfos.push(techInfo);
    },
    getCategoriesList(list) {
      if (this.$store.getters.tradeRequestCategoryType != 'Product') {
        let techInfo = [];
        this.categoriesList = list;
        this.categoriesList.forEach((x) => {
          techInfo.push({
            processType:
              x.productionProcessType == 'MainProcess'
                ? 'MainProcess'
                : 'SubProcess',
            productCategoryId: x.categoryId,
            tradeRequestItemPropertyValues: [],
          });
        });
        this.form.techInfos = techInfo;
      }
    },

    changeCloseStepper(val) {
      this.closeStepper = val;
    },
    fillEditInput() {
      if (
        this.$store.getters.tradeRequestEditMode &&
        this.$store.getters.tradeRequestSingleItemForEdit &&
        Object.keys(this.$store.getters.tradeRequestSingleItemForEdit).length
      ) {
        this.DeliveryDurationType();
        this.getRawMaterial();
        if (!this.$store.getters.tradeRequestIsEdit) {
          this.form = this.$store.getters.tradeRequestSingleItemForEdit;
        } else {
          if (
            this.$store.getters.tradeRequestSingleItemForEdit &&
            Object.keys(this.$store.getters.tradeRequestSingleItemForEdit)
              .length
          ) {
            this.getUnitsOfMeasurement(
              this.$store.getters.tradeRequestSingleItemForEdit
                .measurementUnitTitle
            );
          }
          let formData = {
            id: this.$store.getters.tradeRequestSingleItemForEdit.id
              ? this.$store.getters.tradeRequestSingleItemForEdit.id
              : null,
            supplierProductId:
              this.$store.getters.tradeRequestSingleItemForEdit
                .supplierProductId ?? this.supplierProductId,
            title: this.$store.getters.tradeRequestSingleItemForEdit.title,
            quantity:
              this.$store.getters.tradeRequestSingleItemForEdit.quantity,
            requireDateUtc:
              this.$store.getters.tradeRequestSingleItemForEdit.requireDateUtc,
            description:
              this.$store.getters.tradeRequestSingleItemForEdit.description,
            materialSupplyType:
              this.$store.getters.tradeRequestSingleItemForEdit
                .materialSupplyType,
            rawMaterialId:
              this.$store.getters.tradeRequestSingleItemForEdit.rawMaterialId,
            documents:
              this.$store.getters.tradeRequestSingleItemForEdit.documents,
            responseDocuments:
              this.$store.getters.tradeRequestSingleItemForEdit
                .responseDocuments,
            techInfos:
              this.$store.getters.tradeRequestSingleItemForEdit.techInfos,
            measurementUnitId:
              this.$store.getters.tradeRequestSingleItemForEdit
                .measurementUnitId,
            inventoryItemId:
              this.$store.getters.tradeRequestSingleItemForEdit.inventoryItemId,
            deliveryType:
              this.$store.getters.tradeRequestSingleItemForEdit.deliveryType,
            deliveryItems:
              this.$store.getters.tradeRequestSingleItemForEdit.deliveryItems,
            deliveryLocation:
              this.$store.getters.tradeRequestSingleItemForEdit
                .deliveryLocation,
            tradeRequestItemType:
              this.$store.getters.tradeRequestSingleItemForEdit
                .tradeRequestItemType,
            technicalHelpNeeded:
              this.$store.getters.tradeRequestSingleItemForEdit
                .technicalHelpNeeded,
          };
          this.form = formData;
          this.categoryDetails = formData.title;
        }
        this.form.documents.forEach((doc) => {
          doc.fileType = doc.fileId.extension;
          this.attachedItems.push(doc);
        });
        //----------------------------responseDocument---------------------------------//
        this.form.responseDocuments.forEach((rd) => {
          this.responseAttachedItems.push(rd);
        });
        //----------------------------------------------------------------------------
        this.deliveryItemsList = this.form.deliveryItems;
        this.deliveryflag = false;
        if (this.deliveryItemsList && this.deliveryItemsList.length) {
          this.singleDeliveryItem = {
            amount:
              this.deliveryItemsList[this.deliveryItemsList.length - 1].amount,
            deliveryDateUtc:
              this.deliveryItemsList[this.deliveryItemsList.length - 1]
                .deliveryDateUtc,
          };
        }

        if (this.form.techInfos && this.form.techInfos.length) {
          this.techInfos = this.form.techInfos;
          let ids = [];
          this.form.techInfos.forEach((x) => {
            ids.push(x.productCategoryId);
            this.productProperties = x.tradeRequestItemPropertyValues;
          });
          this.categoryIds = ids;
        }
      }
    },

    getRawMaterial() {
      const loader = this.$loading.show();
      rawMaterialRepository()
        .getRawMaterial(this.productBaseUrl)
        .then((res) => {
          this.rawMaterials = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },

    getUnitsOfMeasurement(el) {
      // const trimInput = el;
      // if (trimInput && trimInput.length >= 2) {
      const loader = this.$loading.show();
      unitOfMeasurementsRepository()
        .getUnitOfMeasurementsList(this.inventoryBaseUrl)
        .then((res) => {
          this.unitMeasurmentItems = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
      // }
    },
    tradeRequestsList() {
      return this.getEnumByTitle('TradeRequestType');
    },
    tradePaymentMethodList() {
      return this.getEnumByTitle('TradePaymentMethodType');
    },
    DeliveryDurationType() {
      return this.getEnumByTitle('DeliveryDurationType');
    },
    rawMaterialSupplyTypes() {
      return this.getEnumByTitle('RawMaterialSupplyType');
    },
    deliveryLocationItems() {
      return this.getEnumByTitle('DeliveryLocationType');
    },
    tradeRequestItemType() {
      return this.getEnumByTitle('TradeRequestItemType');
    },
    uploadFile(file) {
      this.file = null;
      const check = this.$refs.file.validate();
      if (!check) {
        return false;
      }
      this.file = file;
      if (file.type == 'application/pdf') {
        this.document.disableCheckBox = true;
        this.document.isDefault = false;
      }

      let fil = new FormData();
      fil.append('file', file);
      const loader = this.$loading.show();
      filesRepository()
        .sendFileWithoutFolderType(fil, this.fileBaseUrl)
        .then(({ data }) => {
          this.document.fileId = data.fileId;
          this.singleAttachedItem = {
            fileName: file.name,
          };
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    getAttachmentFileList() {
      const loader = this.$loading.show();
      let params = {
        requestType: this.request,
        categories: this.category,
        flow: 'TradeRequest',
        PageNumber: 1,
        ItemsPerPage: 9999,
      };
      tradeRequestRepository()
        .getDocumentType(this.baseUrl, {}, params)
        .then((res) => {
          // this.attachInformationFileList = res.data;
          this.attachInformationFileList = res.data.list.filter((item) => {
            return item.disabled == false;
          });

          //
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    getAttachmentFileListForResponse() {
      const loader = this.$loading.show();
      let params = {
        requestType: this.request,
        categories: this.category,
        flow: 'TradeResponse',
        PageNumber: 1,
        ItemsPerPage: 9999,
      };
      tradeRequestRepository()
        .getDocumentType(this.baseUrl, {}, params)
        .then((res) => {
          this.attachInformationFileListForResponse = res.data.list.filter(
            (item) => {
              return item.disabled == false;
            }
          );

          //
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    responseDocumentAddFile() {
      if (this.responseDocument.documentTypeId) {
        let responseDocumentId = uuid.v4();
        this.form.responseDocuments.push({
          isOptional: this.responseDocument.isOptional,
          documentTypeId: this.responseDocument.documentTypeId,
          subTitle: this.responseDocument.subTitle,
          responseDocumentId: responseDocumentId,
        });
        let singleResponse = null;
        this.attachInformationFileListForResponse.forEach((x) => {
          if (x.id == this.responseDocument.documentTypeId) {
            singleResponse = {
              isOptional: this.responseDocument.isOptional,
              documentTypeId: this.responseDocument.documentTypeId,
              subTitle: this.responseDocument.subTitle,
              responseDocumentId: responseDocumentId,
              documentTypeTitle: x.title,
            };
          }
        });
        this.responseAttachedItems.push(singleResponse);

        this.responseDocument = {
          isOptional: false,
          documentTypeId: null,
          subTitle: '',
        };
      }
    },
    removeResponseAttachedItem(item) {
      let flag = true;
      if (this.$store.getters.tradeRequestIsEdit) {
        this.responseAttachedItems.forEach((x, i) => {
          if (JSON.stringify(x) == JSON.stringify(item)) {
            this.responseAttachedItems.splice(i, 1);
          }
        });
        this.form.responseDocuments.forEach((x, i) => {
          if (flag) {
            if (x.id && item.id && x.id == item.id) {
              this.form.responseDocuments.splice(i, 1);
              flag = false;
            } else if (
              x.responseDocumentId &&
              item.responseDocumentId &&
              x.responseDocumentId == item.responseDocumentId
            ) {
              this.form.responseDocuments.splice(i, 1);
              flag = false;
            }
          }
        });
      } else {
        this.responseAttachedItems.forEach((x, i) => {
          if (JSON.stringify(x) == JSON.stringify(item)) {
            this.responseAttachedItems.splice(i, 1);
          }
        });
        this.form.responseDocuments.forEach((x, i) => {
          if (
            x.responseDocumentId &&
            item.responseDocumentId &&
            x.responseDocumentId == item.responseDocumentId
          ) {
            this.form.responseDocuments.splice(i, 1);
          }
        });
      }
    },
    addFile() {
      if (
        this.form.documents &&
        this.document.fileId &&
        this.document.fileId.length &&
        this.document.documentTypeId &&
        this.document.documentTypeId.length
      ) {
        let fileUniqueId = uuid.v4();
        ////------------------////
        if (this.document.isDefault) {
          this.form.documents.forEach((item) => {
            item.isDefault = false;
          });
          this.attachedItems.forEach((item) => {
            item.isDefault = false;
          });
        }

        ///--------------------////
        this.form.documents.push({
          isDefault: this.document.isDefault,
          categoryType: this.$store.getters.tradeRequestCategoryType,
          documentTypeId: this.document.documentTypeId,
          fileId: this.document.fileId,
          description: this.document.description,
          expirationDateUtc: this.document.expirationDateUtc,
          fileUniqueId: fileUniqueId,
        });
        this.attachInformationFileList.forEach((x) => {
          if (x.id == this.document.documentTypeId) {
            this.singleAttachedItem = {
              icon: 'mdi-close',
              description: this.document.description,
              isDefault: this.document.isDefault,
              type: x.title,
              documentTypeTitle: x.title,
              fileSize: this.file.size,
              fileType: this.file.type,
              fileUniqueId: fileUniqueId,

              ...this.singleAttachedItem,
            };
          }
        });

        this.attachedItems.push(this.singleAttachedItem);
        this.document = {
          documentTypeId: null,
          fileId: '',
          description: '',
          expirationDateUtc: '',
          isDefault: false,
          disableCheckBox: false,
        };

        ///-------------------------------validation -----------------------------------////

        // if(this.form.documents.length == this.attachInformationFileList.length ){
        //   this.validationErr.validate = true
        // }
        // else if(this.form.documents.length < this.attachInformationFileList.length ){
        let ids = [];
        this.form.documents.forEach((x) => {
          ids.push(x.documentTypeId);
        });
        if (this.validationErr.validate) {
          this.attachInformationFileList.forEach((x) => {
            if (this.validationErr.validate && x.required) {
              if (!ids.includes(x.id)) {
                this.validationErr = {
                  validate: false,
                  errorMessage: 'برای تمام آیتم های اجباری مدارک آپلود کنید. ',
                };
                return;
              }
            }
          });
        } else {
          let flag = false;
          this.attachInformationFileList.forEach((x) => {
            if (!this.validationErr.validate && x.required) {
              if (!ids.includes(x.id)) {
                flag = false;
              } else {
                flag = true;
              }
            }
          });
          if (flag) {
            this.validationErr = { validate: true, errorMessage: '' };
          }
          //  }
        }
      }
    },
    addToDefault(item) {
      let flag = true;
      this.form.documents.forEach((x, i) => {
        // if (flag) {
        if (x.id && item.id && x.id == item.id) {
          x.isDefault = true;
          // flag = false;
        } else if (
          x.fileUniqueId &&
          item.fileUniqueId &&
          x.fileUniqueId == item.fileUniqueId
        ) {
          x.isDefault = true;
          // flag = false;
        } else {
          x.isDefault = false;
        }
        // }
      });
      this.attachedItems.forEach((x, i) => {
        //
        if (x.id && item.id && x.id == item.id) {
          x.isDefault = true;
          // flag = false;
        } else if (
          x.fileUniqueId &&
          item.fileUniqueId &&
          x.fileUniqueId == item.fileUniqueId
        ) {
          //
          x.isDefault = true;
        } else {
          x.isDefault = false;
        }
      });
    },
    removeAttachedItem(item) {
      let flag = true;
      if (this.$store.getters.tradeRequestIsEdit) {
        this.attachedItems.forEach((x, i) => {
          if (JSON.stringify(x) == JSON.stringify(item)) {
            this.attachedItems.splice(i, 1);
          }
        });
        this.form.documents.forEach((x, i) => {
          if (flag) {
            if (x.id && item.id && x.id == item.id) {
              this.form.documents.splice(i, 1);
              flag = false;
            } else if (
              x.fileUniqueId &&
              item.fileUniqueId &&
              x.fileUniqueId == item.fileUniqueId
            ) {
              this.form.documents.splice(i, 1);
              flag = false;
            }
          }
        });
      } else {
        this.attachedItems.forEach((x, i) => {
          if (JSON.stringify(x) == JSON.stringify(item)) {
            this.attachedItems.splice(i, 1);
          }
        });
        this.form.documents.forEach((x, i) => {
          if (
            x.fileUniqueId &&
            item.fileUniqueId &&
            x.fileUniqueId == item.fileUniqueId
          ) {
            this.form.documents.splice(i, 1);
          }
        });
      }

      // this.attachInformationFileList.forEach((x,i)=>{
      //   if(x.title == item.type || x.title == item.documentTypeTitle){
      //     x.disabled = false
      //   }
      // })
      //------------------------------validation -------------------------
      let ids = [];
      this.form.documents.forEach((x) => {
        ids.push(x.documentTypeId);
      });
      if (this.validationErr.validate) {
        this.attachInformationFileList.forEach((x) => {
          if (this.validationErr.validate && x.required) {
            if (!ids.includes(x.id)) {
              this.validationErr = {
                validate: false,
                errorMessage: 'برای تمام آیتم های اجباری مدارک آپلود کنید. ',
              };
              return;
            }
          }
        });
      }
    },
    documentValidation() {
      let ids = [];
      this.form.documents.forEach((x) => {
        ids.push(x.documentTypeId);
      });
      if (this.validationErr.validate) {
        this.attachInformationFileList.forEach((x) => {
          if (this.validationErr.validate && x.required) {
            if (!ids.includes(x.id)) {
              this.validationErr = {
                validate: false,
                errorMessage: 'برای تمام آیتم های اجباری مدارک آپلود کنید. ',
              };
              return;
            }
          }
        });
      }
      if (!this.validationErr.validate) {
        this.$dialog.error({
          text: 'اطلاعات مربوط به تمام آیتم های اجباری در فایل اطلاعات پیوست را بارگزاری کنید',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      } else {
        this.stepperProp = this.stepperProp + 1;
      }
    },
    responseDocumentValidation() {
      this.stepperProp = this.stepperProp + 1;
    },
    addDeliveryItem() {
      if (
        this.form.quantity > 0 &&
        this.form.requireDateUtc != null &&
        this.form.requireDateUtc != ''
      ) {
        if (this.form.deliveryType == 'Periodical') {
          let deliveyItemsAmount = 0;
          this.deliveryItemsList.forEach((x) => {
            deliveyItemsAmount = deliveyItemsAmount + parseInt(x.amount);
          });

          if (
            parseInt(deliveyItemsAmount) +
              parseInt(this.singleDeliveryItem.amount) <
            parseInt(this.form.quantity)
          ) {
            this.singleDeliveryItem.amount = parseInt(
              this.singleDeliveryItem.amount
            );
            this.deliveryItemsList.push({
              amount: this.singleDeliveryItem.amount,
              deliveryDateUtc: this.singleDeliveryItem.deliveryDateUtc,
            });
            this.form.deliveryItems = this.deliveryItemsList;

            this.singleDeliveryItem = { amount: null, deliveryDateUtc: null };
          } else if (
            parseInt(deliveyItemsAmount) +
              parseInt(this.singleDeliveryItem.amount) ==
            parseInt(this.form.quantity)
          ) {
            this.singleDeliveryItem.amount = parseInt(
              this.singleDeliveryItem.amount
            );
            this.deliveryItemsList.push(this.singleDeliveryItem);
            this.form.deliveryItems = this.deliveryItemsList;
          } else if (
            parseInt(deliveyItemsAmount) +
              parseInt(this.singleDeliveryItem.amount) >
            parseInt(this.form.quantity)
          ) {
            this.$dialog.message.error(
              ' مجموع تعداد اقلام انتخاب شده نباید از تعداد کالا بیشتر شود. ',
              {
                position: 'top-left',
              }
            );
          }
        } else {
          if (
            parseInt(this.singleDeliveryItem.amount) <
              parseInt(this.form.quantity) ||
            parseInt(this.singleDeliveryItem.amount) >
              parseInt(this.form.quantity)
          ) {
            this.$dialog.message.error(
              ' مجموع تعداد اقلام انتخاب شده باید برابر با تعداد کالا شود. ',
              {
                position: 'top-left',
              }
            );
            this.deliveryflag = true;
          } else if (this.singleDeliveryItem.amount == this.form.quantity) {
            this.singleDeliveryItem.amount = parseInt(
              this.singleDeliveryItem.amount
            );
            this.deliveryItemsList = [];

            this.deliveryItemsList.push(this.singleDeliveryItem);
            this.form.deliveryItems = this.deliveryItemsList;

            this.deliveryflag = false;
          }
        }
      } else if (
        (this.form.quantity == 0 || this.form.quantity == null) &&
        (this.form.requireDateUtc == null || this.form.requireDateUtc == '')
      ) {
        this.$dialog.message.error(
          ' ابتدا تعداد کالا و تاریخ شروع تحویل دهی را انتخاب نمایید ',
          {
            position: 'top-left',
          }
        );
      } else if (this.form.quantity == 0 || this.form.quantity == null) {
        this.$dialog.message.error(' ابتدا تعداد کالا را انتخاب نمایید ', {
          position: 'top-left',
        });
      } else if (
        this.form.requireDateUtc == null ||
        this.form.requireDateUtc == ''
      ) {
        this.$dialog.message.error(
          ' ابتدا تاریخ شروع تحویل دهی را انتخاب نمایید ',
          {
            position: 'top-left',
          }
        );
      }
    },
    removeDeliveryItem(item) {
      this.deliveryItemsList.forEach((x, i) => {
        if (JSON.stringify(x) == JSON.stringify(item)) {
          this.deliveryItemsList.splice(i, 1);
        }
      });
      this.form.deliveryItems.forEach((x, i) => {
        if (JSON.stringify(x) == JSON.stringify(item)) {
          this.form.deliveryItems.splice(i, 1);
        }
      });
    },
    deliveryItemsValidation() {
      if (this.form.deliveryItems.length > 0)
        if (this.form.deliveryType == 'Periodical') {
          let deliveyItemsAmount = 0;
          this.deliveryItemsList.forEach((x) => {
            deliveyItemsAmount = deliveyItemsAmount + parseInt(x.amount);
          });
          if (parseInt(deliveyItemsAmount) < parseInt(this.form.quantity)) {
            this.$dialog.error({
              text: 'مجموع تعداد اقلام در حالت ادواری باید برابر با تعداد کل کالا باشد',
              title: 'خطا',
              persistent: true,
              actions: [
                {
                  text: 'بستن',
                  color: 'red',
                },
              ],
            });
          } else if (
            parseInt(deliveyItemsAmount) == parseInt(this.form.quantity)
          ) {
            this.stepperProp = 3;
          }
        } else {
          this.stepperProp = 3;
        }
      else {
        this.$dialog.error({
          text: 'آیتم های تحویل دهی را ثبت کنید',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },
    async addOrEditItem() {
      //we should controle 3 mode
      ///Case 1/سفارش در حال ایجاد بوده و اقلام سفارش می توانند اضافه شوند، ، اضافه شده ویرایش شود
      ///Case 2/سفارش ثبت شده قبلی قابل ویرایش جهت ویرایش انتخاب شده و اقلام موجود ویرایش شده، اقلام جدید اضافه شوند یا ویرایش شوند
      ////All the case we should check the unique Supplier for all items

      //اینو در زمان ذخیره ویرایش قلم باید صدا زد
      //this.$store.commit('setTradeRequestSingleItemForEdit', item);

      let ids = [];
      this.form.documents.forEach((x) => {
        ids.push(x.documentTypeId);
      });

      if (this.$refs.itemForm.validate()) {
        //Case 1 Adding new Item
        // if (
        //   this.$store.getters.tradeRequestEditMode &&
        //   !this.$store.getters.tradeRequestSelectedForEdit
        // ) {

        if (
          !this.$store.getters.tradeRequestEditMode &&
          !this.$store.getters.tradeRequestItemEditMode
        ) {
          console.log('addOrEditItem IF:1');

          this.$emit('isItemsAddingAction', true);
          this.$store.commit(
            'setTradeRequestSingleItem',
            JSON.parse(JSON.stringify(this.form))
          );
          this.$emit('editBtnPressedFunc', false);
          this.stepperProp = 5;
          // this.form.documents = [];
          this.clearFormAfterAddedToStore();
          // this.form = {
          //   title: '',
          //   quantity: '',
          //   requireDateUtc: null,
          //   description: '',
          //   materialSupplyType: '',
          //   rawMaterialId: null,
          //   documents: [],
          //   techInfos: [],
          //   measurementUnitId: null,
          //   inventoryItemId: null,
          //   deliveryType: null,
          //   deliveryItems: [],
          //   deliveryLocation: '',
          //   tradeRequestItemType: '',
          //   technicalHelpNeeded: false,
          //   responseDocuments: null,
          // };
          //this.responseAttachedItems = [];
          this.attachedItems = [];
          // await this.resestForm();
          //this.resetTree = false;
          //this.resetTree = true;
          let temp = this.$store.getters.tradeRequestCategoryType;
          this.$store.commit('setTradeRequestCategoryType', null);
          this.$store.commit('setTradeRequestCategoryType', temp);
          this.DeliveryDurationType();
          this.getRawMaterial();
          this.getAttachmentFileList();
          this.getAttachmentFileListForResponse();
          this.closeStepper = true;
          this.stepperProp = 5;
          this.formHasItem = true;
          //this.addItemDisabled = false;
        }
        ///Case 1 Editing an item
        else if (
          !this.$store.getters.tradeRequestEditMode &&
          this.$store.getters.tradeRequestItemEditMode
        ) {
          console.log('addOrEditItem IF:2');
          console.log('Case 1 Editing an item');

          let uniqueId = uuid.v4();
          this.form = { uniqueId: uniqueId, ...this.form };

          this.$store.commit('editItemInTradeRequestItems', this.form); //

          // this.$store.commit(
          //   'setTradeRequestSingleItem',
          //   JSON.parse(JSON.stringify(this.form))
          // );
          this.$emit('editBtnPressedFunc', true);
          this.clearFormAfterAddedToStore();
          // this.form = {
          //   title: '',
          //   quantity: '',
          //   requireDateUtc: null,
          //   description: '',
          //   materialSupplyType: '',
          //   rawMaterialId: null,
          //   documents: [],
          //   techInfos: [],
          //   measurementUnitId: null,
          //   inventoryItemId: null,
          //   deliveryType: null,
          //   deliveryItems: [],
          //   deliveryLocation: '',
          //   tradeRequestItemType: '',
          //   technicalHelpNeeded: false,
          //   responseDocuments: null,
          // };
          //this.responseAttachedItems = [];

          this.attachedItems = [];
          // await this.resestForm();

          //this.resetTree = false;
         // this.resetTree = true;
          let temp = this.$store.getters.tradeRequestCategoryType;
          this.$store.commit('setTradeRequestCategoryType', null);
          this.$store.commit('setTradeRequestCategoryType', temp);
          this.DeliveryDurationType();
          this.getRawMaterial();
          this.getAttachmentFileList();
          this.getAttachmentFileListForResponse();
          this.closeStepper = true;
          this.stepperProp = 5;
          this.formHasItem = true;
          this.addItemDisabled = false;
        } else if (
          !this.$store.getters.tradeRequestEditMode &&
          this.$store.getters.tradeRequestSelectedForEdit
        ) {
          console.log('addOrEditItem IF:3');
          console.log('Rezaaaaaaaaaaaaaaa');
          //add an item in a previously created form
          console.log('add an item in a previously created form');
          let uniqueId = uuid.v4();
          this.form = { uniqueId: uniqueId, ...this.form };

          this.$store.commit(
            'setTradeRequestSingleItem',
            JSON.parse(JSON.stringify(this.form))
          );
          this.$emit('editBtnPressedFunc', true);
          this.clearFormAfterAddedToStore();
          // this.form = {
          //   title: '',
          //   quantity: '',
          //   requireDateUtc: null,
          //   description: '',
          //   materialSupplyType: '',
          //   rawMaterialId: null,
          //   documents: [],
          //   techInfos: [],
          //   measurementUnitId: null,
          //   inventoryItemId: null,
          //   deliveryType: null,
          //   deliveryItems: [],
          //   deliveryLocation: '',
          //   tradeRequestItemType: '',
          //   technicalHelpNeeded: false,
          //   responseDocuments: null,
          // };
         // this.responseAttachedItems = [];

          this.attachedItems = [];
          // await this.resestForm();

          //this.resetTree = false;
          //this.resetTree = true;
          let temp = this.$store.getters.tradeRequestCategoryType;
          this.$store.commit('setTradeRequestCategoryType', null);
          this.$store.commit('setTradeRequestCategoryType', temp);
          this.DeliveryDurationType();
          this.getRawMaterial();
          this.getAttachmentFileList();
          this.getAttachmentFileListForResponse();
          this.closeStepper = true;
          this.stepperProp = 5;
          this.formHasItem = true;
          this.addItemDisabled = false;
        } else if (
          //tradeRequestSelectedForEdit is a tradeRequestCompletData not item for edit selected
          !this.$store.getters.tradeRequestEditMode &&
          !this.$store.getters.tradeRequestSelectedForEdit
        ) {
          console.log('addOrEditItem IF:4');
          //create new item
          let uniqueId = uuid.v4();
          this.form = { uniqueId: uniqueId, ...this.form };

          this.$store.commit(
            'setTradeRequestSingleItem',
            JSON.parse(JSON.stringify(this.form))
          );
          this.$emit('editBtnPressedFunc', true);
          this.$emit('isItemsAddingAction', true);
          this.clearFormAfterAddedToStore();
          // this.form = {
          //   title: '',
          //   quantity: '',
          //   requireDateUtc: null,
          //   description: '',
          //   materialSupplyType: '',
          //   rawMaterialId: null,
          //   documents: [],
          //   techInfos: [],
          //   measurementUnitId: null,
          //   inventoryItemId: null,
          //   deliveryType: null,
          //   deliveryItems: [],
          //   deliveryLocation: '',
          //   tradeRequestItemType: '',
          //   technicalHelpNeeded: false,
          //   responseDocuments: null,
          // };
         // this.responseAttachedItems = [];

          this.attachedItems = [];
          //await this.resestForm();

         // this.resetTree = false;

         // this.resetTree = true;

          let temp = this.$store.getters.tradeRequestCategoryType;

          this.$store.commit('setTradeRequestCategoryType', null);
          this.$store.commit('setTradeRequestCategoryType', temp);

          this.DeliveryDurationType();

          this.getRawMaterial();

          this.getAttachmentFileList();
          this.getAttachmentFileListForResponse();

          this.closeStepper = true;
          this.stepperProp = 5;
          this.formHasItem = true;
          this.addItemDisabled = false;
        } else if (
          this.$store.getters.tradeRequestEditMode &&
          this.$store.getters.tradeRequestItemEditMode
        ) {
          //edit a previously created item
          console.log('addOrEditItem IF:5');
          console.log(
            'edit new item rrrrrrrrrrrrrrrrrrrrrrrrrrrrr + this.form'
          );
          this.$emit('isItemsAddingAction', false);
          this.$store.commit(
            'setTradeRequestSingleItem',
            JSON.parse(JSON.stringify(this.form))
          );
          console.log(this.form);
          // this.$emit('updateItemsList',this.form.id);

          // this.form = {
          //   title: '',
          //   quantity: '',
          //   requireDateUtc: null,
          //   description: '',
          //   materialSupplyType: '',
          //   rawMaterialId: null,
          //   documents: [],
          //   techInfos: [],
          //   measurementUnitId: null,
          //   inventoryItemId: null,
          //   deliveryType: null,
          //   deliveryItems: [],
          //   deliveryLocation: '',
          //   tradeRequestItemType: '',
          //   technicalHelpNeeded: false,
          //   responseDocuments: null,
          // };
          this.clearFormAfterAddedToStore();
          this.$emit('editBtnPressedFunc', true);
          //this.responseAttachedItems = [];

          this.attachedItems = [];
          //await this.resestForm();
          //this.resetTree = false;
          //this.resetTree = true;
          let temp = this.$store.getters.tradeRequestCategoryType;
          this.$store.commit('setTradeRequestCategoryType', null);
          this.$store.commit('setTradeRequestCategoryType', temp);
          this.DeliveryDurationType();
          this.getRawMaterial();
          this.getAttachmentFileList();
          this.getAttachmentFileListForResponse();
          this.closeStepper = true;
          this.stepperProp = 5;
          this.formHasItem = true;
          this.addItemDisabled = false;
        }
      } else if (!this.$refs.itemForm.validate()) {
        this.addItemDisabled = false;
        this.$dialog.error({
          text: 'وارد کردن موارد ستاره دار الزامی می‌باشد',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },
    clearFormAfterAddedToStore() {
      this.form = {
        title: '',
        quantity: '',
        requireDateUtc: null,
        description: '',
        materialSupplyType: '',
        rawMaterialId: null,
        documents: [],
        techInfos: [],
        measurementUnitId: null,
        inventoryItemId: null,
        deliveryType: null,
        deliveryItems: [],
        deliveryLocation: '',
        tradeRequestItemType: '',
        technicalHelpNeeded: false,
        responseDocuments: null,
      };
      this.responseDocument = {
        isOptional: false,
        subTitle: '',
        documentTypeId: null,
      };
      this.secondFormValid = true;
      this.thirdFormValid = true;
      this.forthFormValid = true;
      this.techInfos = [];
      this.productProperties = [];
      this.form.documents = [];
      this.closeStepper = false;
      // this.categoryType=null
      this.editDeliveryFlag = false;
      this.categoriesList = [];
      this.resetTree = false;
      (this.deliveryflag = false),
        (this.deliveryItemsList = []),
        (this.tempStorage = []),
        (this.singleAttachedItem = {}),
        (this.attachedItems = []),
        (this.responseAttachedItems = []),
        (this.measurementUnit = ''),
        (this.titleLoading = false),
        (this.rawMaterial = []),
        (this.showUploadForm = false),
        (this.loadingCategoryTree = false),
        (this.resetForm = false),
        (this.unitMeasurmentItems = []),
        (this.form = { ...initialFormData }),
        (this.form.documents = []);
      (this.attachInformationFileList = []),
        (this.attachInformationFileSelected = ''),
        (this.deliveryDurationItems = []),
        (this.file = null),
        (this.categoryItems = []),
        (this.categoryListItems = []),
        (this.itemValid = true),
        (this.productCategoryId = null),
        (this.validationErr = {
          validate: true,
          errorMessage: '',
        }),
        (this.singleDeliveryItem = {
          deliveryDateUtc: null,
          amount: null,
        }),
        (this.document = {
          documentTypeId: null,
          fileId: '',
          description: '',
          expirationDateUtc: '',
          isDefault: false,
          disableCheckBox: false,
        });
         this.responseAttachedItems = [];
    },
    translate(en) {
      const Fa = {
        IndustrialService: 'ساخت و تولید',
        Product: 'کالای صنعتی',
        ConsultingService: 'طراحی و مشاوره صنعتی',
        ElectronicDocument: 'استانداردهای صنعتی',
      };

      return Fa[en];
    },
    selectedItem(selected) {
      if (selected.length) {
        this.form.title = selected[0].title;
      } else {
        this.form.title = '';
      }
    },
    // OnchangeDateMoment() {
    //   console.log('Date changed');
    //   console.log(this.form.requireDateUtc);
    // },
    selectedDataFunc(selected) {
      let unableToSelectCorrectly = false;
      this.supplierProduct = selected;
      if (
        this.selectedSupplierId != selected[0].supplierId ||
        this.selectedCategoryType != selected[0].categoryType
      ) {
        unableToSelectCorrectly = true;
        this.form.title = '';
        this.categoryDetails = '';
        this.$dialog.error({
          text: 'هر سفارش باید برای یک تامین کننده باشد، در انتخاب مالا یا خدمات تامین کنندگان دقت فرمایید ',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
      if (!unableToSelectCorrectly) {
        this.categoryDetails =
          this.translate(this.supplierProduct[0]?.categoryType) +
          ' / ' +
          this.supplierProduct[0]?.name +
          ' / تامین کننده : ' +
          this.supplierProduct[0]?.supplierName;
      }
    },
  },
};
</script>
